import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { Requestdynamic } from '../../Network/Fetch';
import { ButtonTestCss } from "../../ButtonStyle";
import Cookies from 'universal-cookie';
import Pagination from './Pagination'; // adapte le chemin selon ton dossier

const SelectEventModal = ({ show, onClose, onSelect, prefillEventId }) => {
  const [loading, setLoading] = useState(prefillEventId ? true : false);
  const [events, setEvents] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [pages, setPages] = useState([{ page: 1, lastKey: null }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);

  const fetchEvents = async (page = 1) => {
    const pageData = pages.find(p => p.page === page);
    if (!pageData) return;

    try {
      setLoading(true);
      setError(null);

      const cookies = new Cookies();
      const Jwt = cookies.get('acces');

      const Params = {
        Body: {
          Jwt,
          NumberOfResult: "10",
          SizeImage: "Medium",
          OnlyWithoutGallery: true,
          ...(pageData.lastKey ? { LastKey: pageData.lastKey } : {})
        }
      };

      const res = await Requestdynamic('_getAllPassedEvent', Params);

      if (res.error || res.data.error) {
        setError("Erreur lors du chargement des événements.");
        return;
      }

      setEvents(res.data.data || []);
      setCurrentPage(page);

      console.log(res)
      // Ajouter la page suivante si un LastKey est retourné
      if (res.data.LastKey && !pages.find(p => p.page === page + 1)) {
        setPages(prev => [...prev, { page: page + 1, lastKey: res.data.LastKey }]);
      }
    } catch (e) {
      setError("Erreur inattendue.");
    } finally {
      setLoading(false);
    }
  };

  const fetchEventById = async (id) => {
    try {
      setLoading(true);
      setError(null);
      const res = await Requestdynamic('_getEventById', { Id: id });

      if (res.error || res.data.error) {
        throw new Error();
      }

      onSelect(res.data.data);
      onClose();
    } catch {
      setError("L'événement fourni est invalide. Veuillez en choisir un.");
      await fetchEvents(); // fallback
    }
  };

  useEffect(() => {
    if (show && !prefillEventId) {
      fetchEvents(1); // ← Recharge la liste au moment où la pop-up est réouverte
    }
  }, [show]);

  const handleConfirm = () => {
    const event = events.find(e => e.Id === selectedId);
    if (event) {
      onSelect(event);
      onClose();
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      fetchEvents(currentPage - 1);
    }
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    if (pages.find(p => p.page === nextPage)) {
      fetchEvents(nextPage);
    }
  };

  return (
    <Modal
  show={show}
  onHide={onClose}
  size="lg"
  backdrop="true"
  centered
  keyboard={false}
  scrollable
>
      <Modal.Header closeButton>
        <Modal.Title>Sélectionner un événement</Modal.Title>
      </Modal.Header>


      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Chargement...</p>
          </div>
        ) : error ? (
          <p className="text-danger text-center">{error}</p>
        ) : (
          <>
          <div className="d-flex flex-column gap-3">
    {events.map((event) => (
      <div
        key={event.Id}
        onClick={() => setSelectedId(event.Id)}
        className={`event-card card shadow-sm d-flex flex-row align-items-center p-3 ${selectedId === event.Id ? 'selected' : ''}`}
      >
      <div
  style={{
    width: '30%',
    height: '100px', // tu forces une hauteur pour que "100%" fonctionne dans l'image
    borderRadius: '8px',
    overflow: 'hidden',
    marginRight: '16px',
    flexShrink: 0
  }}
>
  <img
    src={event.Image}
    alt={event.Name}
    loading="lazy"
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }}
  />
</div>

        <div className="flex-grow-1">
          <h5 className="mb-1">{event.Name}</h5>
          <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>{event.DateEvent}</p>
        </div>

        {/* Radio cachée mais logique conservée */}
        <input
          type="radio"
          checked={selectedId === event.Id}
          onChange={() => setSelectedId(event.Id)}
          style={{ display: 'none' }}
        />
      </div>
    ))}
  </div>




          </>
        )}
      </Modal.Body>

      <div className="px-3 pt-2 pb-1  bg-white" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
    <Pagination
      currentPage={currentPage}
      totalPages={pages.length}
      hasNextPage={!!pages.find(p => p.page === currentPage + 1)}
      onPageChange={(page) => {
        const pageExists = pages.find(p => p.page === page);
        if (pageExists) fetchEvents(page);
      }}
    />
    </div>
      <Modal.Footer>
        <ButtonTestCss
          color={"orange"}
          disabled={!selectedId}
          onClick={handleConfirm}
        >
          Confirmer
        </ButtonTestCss>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectEventModal;
